import isObject from 'lodash/isObject'

export default {
  namespaced: true,
  state: {
    items: [],
    isPurchasing: false,
  },
  getters: {
    items (state) {
      return state.items
    },
    itemsOf: (state, getters) => (category) => {
      return getters.items.filter((item) => getters.checkCategory(category, item))
    },
    checkPurchased: () => (item) => {
      const purchases = item.purchases || []
      return purchases.length > 0
    },
    isPurchasing (state) {
      return state.isPurchasing
    },
    checkCategory: (state, getters) => (category, item) => {
      const found = getters.categories.find(({ value }) => value == category)
      if (found) {
        category = found
      }
      if (isObject(category)) {
        return category.categories.includes(item.category)
      }
      return item.category == category
    },
    purchasedItems (state, getters) {
      return getters.items.filter(getters.checkPurchased)
    },
    categories () {
      return [
        {
          value: 'clothes',
          categories: ['clothes.decoration', 'clothes.top'],
          label: '衣服'
        },
        {
          value: 'accessory',
          categories: ['hat', 'accessory.collar', 'accessory.napkin', 'accessory.ribbon'],
          label: '飾物'
        },
        {
          value: 'shoes',
          categories: ['shoes'],
          label: '鞋'
        },
        {
          value: 'toy',
          categories: ['toy.face', 'toy.food', 'toy.ball'],
          label: '玩具'
        },
      ]
    },
  },
  mutations: {
    REPLACE_ITEM (state, item) {
      const index = state.items.findIndex(({ id }) => id == item.id)
      state.items = [
        ...state.items.slice(0, index),
        item,
        ...state.items.slice(index + 1),
      ]
    },
    SET_ITEMS (state, items) {
      state.items = items
    },
    SET_PURCHASING (state, flag) {
      state.isPurchasing = flag
    },
  },
  actions: {
    async getItems ({ commit, dispatch }) {
      const { data } = await dispatch('http/get', {
        url: '/shop',
      }, { root: true })
      commit('SET_ITEMS', data)
    },
    async purchase ({ commit, dispatch }, item) {
      commit('SET_PURCHASING', true)
      try {
        const { data } = await dispatch('http/post', {
          url: '/shop/item',
          data: { item_id: item.id },
        }, { root: true })
        commit('REPLACE_ITEM', data)
        await dispatch('auth/getProfile', null, { root: true })
      } catch (e) {
        //
      } finally {
        commit('SET_PURCHASING', false)
      }
    },
    async itemOn ({ commit, dispatch }, item) {
      await dispatch('otherItemsOff', item)
      const { data } = await dispatch('http/put', {
        url: '/shop/item',
        data: { item_id: item.id, apply: true },
      }, { root: true })
      commit('REPLACE_ITEM', data)
    },
    async itemOff ({ commit, dispatch }, item) {
      const { data } = await dispatch('http/put', {
        url: '/shop/item',
        data: { item_id: item.id, apply: false },
      }, { root: true })
      commit('REPLACE_ITEM', data)
    },
    async otherItemsOff ({ dispatch, getters }, item) {
      const otherItems = getters.purchasedItems.filter((otherItem) => {
        return otherItem.group == item.group && otherItem.id !== item.id
      })
      return Promise.all(otherItems.map(
        async (otherItem) => await dispatch('itemOff', otherItem)
      ))
    },
  },
}
